DW.CookieBar = function(bar, barHide) {
    this.bar = bar;
    this.barHide = barHide;
    
    barHide.addEventListener('click', this.hideBar.bind(this));

    if (Cookies.get('cookiesAccepted') !== '1') {
        bar.classList.add('active');
    }
};

DW.CookieBar.prototype.hideBar = function(ev) {
    ev.preventDefault();
    this.bar.classList.remove('active');
    Cookies.set('cookiesAccepted', '1');
};
